/**************************************************************************************************************************************************
*   MODULE NAME     :  Api Base
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  08-02-2021
*   DESCRIPTION     :  Base API function
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import Axios from 'axios';

function ApiBase() {
  this.get = (api, params) => {
    return Axios.get(api, params);
  };
  this.post = (api, params) => {
    return Axios.post(api, params);
  };
  this.put = (api, params) => {
    return Axios.post(api, params);
  };
}
export default new ApiBase();
